<template>
    <div class="rr-search-wrapper" ref="searchContainer">
        <input
            type="text"
            v-model="searchQuery"
            class="rr-search-input"
            placeholder="Search resume requests..."
            @input="onInput"
            @focus="handleFocus"
        >
        <button
            v-if="searchQuery"
            type="button"
            class="rr-search-clear"
            aria-label="Clear"
            @click="clearSearch"
        >&times;</button>

        <div v-if="isSearching" class="rr-search-status">Searching...</div>

        <div v-if="showDropdown && searchResults.length" class="rr-search-results">
            <div
                v-for="(request, index) in searchResults"
                :key="request.id || index"
                class="rr-search-item"
                @click="selectRequest(request)"
            >
                <div class="rr-search-item-name">{{ patientName(request) }}</div>
                <div class="rr-search-item-product">{{ request.product_name || 'N/A' }}</div>
            </div>
        </div>

        <div
            v-if="searchQuery && !searchResults.length && !isSearching && searchPerformed && showDropdown"
            class="rr-search-status"
        >
            No resume requests found.
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { patientName } from './resumeRequestHelpers';

const SEARCH_DEBOUNCE_MS = 300;

export default {
    name: 'SearchResumeRequests',

    data() {
        return {
            searchQuery: '',
            searchResults: [],
            isSearching: false,
            searchPerformed: false,
            showDropdown: false,
            searchTimer: null,
        };
    },

    mounted() {
        document.addEventListener('click', this.handleOutsideClick);
    },

    beforeDestroy() {
        document.removeEventListener('click', this.handleOutsideClick);
        clearTimeout(this.searchTimer);
    },

    methods: {
        patientName,

        onInput() {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(this.search, SEARCH_DEBOUNCE_MS);
        },

        search() {
            const query = this.searchQuery.trim();

            if (!query) {
                this.searchResults = [];
                this.searchPerformed = false;
                this.showDropdown = false;
                this.$emit('user-selected', []);
                return;
            }

            this.isSearching = true;
            this.searchPerformed = true;

            axios
                .get('/api/v1/resume-requests', { params: { search: query } })
                .then((response) => {
                    const data = response.data && response.data.data;
                    this.searchResults = Array.isArray(data) ? data : [];
                    this.showDropdown = true;
                })
                .catch(() => {
                    this.searchResults = [];
                    this.showDropdown = true;
                })
                .finally(() => {
                    this.isSearching = false;
                });
        },

        selectRequest(request) {
            this.$emit('user-selected', [request]);
            this.showDropdown = false;
            this.searchQuery = this.patientName(request);
        },

        clearSearch() {
            this.searchQuery = '';
            this.searchResults = [];
            this.searchPerformed = false;
            this.showDropdown = false;
            this.$emit('user-selected', []);
        },

        handleFocus() {
            if (this.searchQuery && this.searchResults.length) {
                this.showDropdown = true;
            }
        },

        handleOutsideClick(event) {
            if (this.$refs.searchContainer && !this.$refs.searchContainer.contains(event.target)) {
                this.showDropdown = false;
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/SearchResumeRequests.vue